export default __webpack_public_path__ + "static/media/FAQ.c3b83bef.svg";